import Search from "../../MainContent/Search/Search";
import Marquee from "../../Marquee/Marquee";


const Decisions_and_Оrders = () => {
    return (
        <div>
            <div className="container">
                <Search />
                <h4 class="pb-4 pt-4 mb-4  ">
                    Қарору фармонҳо
                </h4>

                <div class="card text-center ">

                    <div class="card-body">
                        <img src="https://maorif.tj/storage/posts/April2017/L6J1wCo56zAs54BRaAze.png" height={50}></img>
                        <div className="pt-3">
                            <a href="https://maorif.tj/storage/Dokument's/af2fe7556c29ca2e686d4420561b9cb3.pdf">
                                <h6 class="card-title">ҚАРОРИ</h6>
                                <h6 class="card-title">ҲУКУМАТИ ҶУМҲУРИИ ТОҶИКИСТОН </h6>
                                <h6 class="card-title">аз 29 августи соли 2017 №411 </h6>
                                <h6 class="card-title">ДАР БОРАИ НИЗОМНОМАИ НАМУНАВИИ МУАССИСАҲОИ ДАВЛАТИИ ТАЪЛИМИИ  </h6>
                                <h6 class="card-title">НАВЪИ МАКТАБ-ИНТЕРНАТ ДАР ҶУМҲУРИИ ТОҶИКИСТОН </h6>
                            </a>
                        </div>
                    </div>
                    <div class="card-body">
                        <img src="https://maorif.tj/storage/posts/April2017/L6J1wCo56zAs54BRaAze.png" height={50}></img>
                        <div className="pt-3">
                            <a href="http://maorif.tj/storage/Dokument's/0910bed2bc375c5f822831c11ab02708.pdf">
                                <h6 class="card-title">ҚАРОРИ</h6>
                                <h6 class="card-title">ҲУКУМАТИ ҶУМҲУРИИ ТОҶИКИСТОН  </h6>
                                <h6 class="card-title">аз 29 сентябри соли 2017 №443  </h6>
                                <h6 class="card-title">ДДАР БОРАИ БАРНОМАИ ДАВЛАТИИ АМАЛӢ НАМУДАНИ ТЕХНОЛОГИЯҲОИ ИТТИЛООТӢ - КОММУНИКАТСИОНӢ ДАР МУАССИСАҲОИ ТАҲСИЛОТИ УМУМИИ
                                    ҶУМҲУРИИ ТОҶИКИСТОН БАРОИ СОЛҲОИ 2018-2022  </h6>
                            </a>
                        </div>
                    </div>
                    <div class="card-body">
                        <img src="https://maorif.tj/storage/posts/April2017/L6J1wCo56zAs54BRaAze.png" height={50}></img>
                        <div className="pt-3">
                            <a href="http://maorif.tj/storage/Dokument's/20ce59cb0e3063b3a13e7a4973ffc528.pdf">
                                <h6 class="card-title">ҚАРОРИ</h6>
                                <h6 class="card-title"> ҲУКУМАТИ ҶУМҲУРИИ ТОҶИКИСТОН</h6>
                                <h6 class="card-title">аз 27 майи соли 2017 №262 </h6>
                                <h6 class="card-title">ДАР БОРАИ ТАРТИБИ ТАҚСИМОТ ВА БО ҶОИ КОР ТАЪМИН НАМУДАНИ МУТАКАССИСОНИ ҶАВОН </h6>
                            </a>
                        </div>
                    </div>
                    <div class="card-body">
                        <img src="https://maorif.tj/storage/posts/April2017/L6J1wCo56zAs54BRaAze.png" height={50}></img>
                        <div className="pt-3">
                            <a href="http://maorif.tj/storage/Dokument's/Qarorho/d293d3bc06003c6511f3cb26e376c7e6.pdf">
                                <h6 class="card-title">ҚАРОРИ</h6>
                                <h6 class="card-title"> ҲУКУМАТИ ҶУМҲУРИИ ТОҶИКИСТОН</h6>
                                <h6 class="card-title">аз 26 ноябри соли 2016 №505  </h6>
                                <h6 class="card-title">Дар бораи тасдиқи Низомномаи намунавӣ оид ба шӯрои диссертатсионӣ, Тартиб додани дараҷаҳои илмӣ ва унвони илмӣ (дотсент, профессор) ва Тартиби бақайдгирии давлатии рисолаҳои илмии ҳимояшуда </h6>
                            </a>
                        </div>
                    </div>
                    <div class="card-body">
                        <img src="https://maorif.tj/storage/posts/April2017/L6J1wCo56zAs54BRaAze.png" height={50}></img>
                        <div className="pt-3">
                            <a href="http://maorif.tj/storage/Dokument's/Qarorho/948f13ba123672f64804935cac548536.pdf">
                                <h6 class="card-title">ҚАРОРИ</h6>
                                <h6 class="card-title"> Ҳукумати Ҷумҳурии Тоҷикистон</h6>
                                <h6 class="card-title">аз 3 майи соли 2006 №197  </h6>
                                <h6 class="card-title">Дар бораи муқаррар намудани имтиёзҳо ба омӯзгорони ҷавон </h6>
                            </a>
                        </div>
                    </div>
                    <div class="card-body">
                        <img src="https://maorif.tj/storage/posts/April2017/L6J1wCo56zAs54BRaAze.png" height={50}></img>
                        <div className="pt-3">
                            <a href="http://maorif.tj/storage/Dokument's/6b38a3093095bd911de6b395fbf528f4.pdf">
                                <h6 class="card-title">ҚАРОРИ</h6>
                                <h6 class="card-title"> Ҳукумати Ҷумҳурии Тоҷикистон</h6>
                                <h6 class="card-title">аз 2 июли соли 2009 №391 </h6>
                                <h6 class="card-title">Дар бораи тасдиқи Қоидаҳои баргардонидани маблағҳои буҷетӣ аз ҳисоби мутахассисони ҷавон,
                                    ки тибқи роҳхат ба ҷои кор ҳозир нашудаанд </h6>
                            </a>
                        </div>
                    </div>
                    <div class="card-body">
                        <img src="https://maorif.tj/storage/posts/April2017/L6J1wCo56zAs54BRaAze.png" height={50}></img>
                        <div className="pt-3">
                            <a href="https://www.maorif.tj/storage/Dokument's/Qarorho/0f9615314c0b95fceea3f16241dd04dc.pdf">

                                <h6 class="card-title">ҚАРОРИ МУШОВАРАИ ВАЗОРАТИ МАОРИФ BA ИЛМИ ҶУМҲУРИИ ТОҶИКИСТОН</h6>
                                <h6 class="card-title"> АЗ 25 ФЕВРАЛИ СОЛИ 2020 №3/74</h6>
                                <h6 class="card-title">ДАР БОРАИ ТАСДИҚИ «ДАСТУРАМАЛИ НАМУНАВИИ НИГОҲДОРИИ ҲУҶҶАТҲО ДАР БОЙГОНИИ МУАССИСАҲОИ ТАЪЛИМИИ ҶУМҲУРИИ ТОҶИКИСТОН»
                                </h6>
                            </a>
                        </div>
                    </div>
                    <div class="card-body">
                        <img src="https://maorif.tj/storage/posts/April2017/L6J1wCo56zAs54BRaAze.png" height={50}></img>
                        <div className="pt-3">
                            <a href="https://www.maorif.tj/storage/Dokument's/e9fead8bbfde45d5180a1c088a672b14.pdf">

                                <h6 class="card-title">ФАРМОНИ ПРЕЗИДЕНТИ ҶУМҲУРИИ ТОҶИКИСТОН</h6>
                                <h6 class="card-title"> ДАР БОРАИ ТАДБИРҲОИ ИЛОВАГӢ ОИД БА ИҶРОИ ҚОНУНИ ҶУМҲУРИИ ТОҶИКИСТОН</h6>
                                <h6 class="card-title">"ДАР БОРАИ МАСЪУЛИЯТИ ПАДАРУ МОДАР ДАР ТАЪЛИМУ ТАРБИЯИ ФАРЗАНД"</h6>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
            <Marquee />
        </div>
    )
}
export default Decisions_and_Оrders;